import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertInvoiceEntry = createAsyncThunk('insertInvoiceEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertInvoiceEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchInvoiceMemo = createAsyncThunk('fetchInvoiceMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getInvoiceMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchInvoiceRegister = createAsyncThunk('fetchInvoiceRegister', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getInvoiceRegister`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const invoiceApiSlice = createSlice({
    name: 'InvoiceDatalist',
    initialState: {
        isLoading: false,
        invMemo: null,
        invReg: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchInvoiceMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchInvoiceMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.invMemo = action.payload;
        });
        builder.addCase(fetchInvoiceMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchInvoiceRegister.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchInvoiceRegister.fulfilled, (state, action) => {
            state.isLoading = false;
            state.invReg = action.payload;
        });
        builder.addCase(fetchInvoiceRegister.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default invoiceApiSlice.reducer;
